export enum Product {
  purposeful = 'purposeful',
  resourceful = 'resourceful',
  insightful = 'insightful',
}
